module.exports = __webpack_public_path__ + "static/img/gift-2.367b7a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/winter-camp/assets/gift-2.png
// module id = 362
// module chunks = 140